import { useMutation, gql } from "@apollo/client"
import { LOCATION_FIELDS } from "./useQueryLocations"

const CREATE_LOCATION_MUTATION = gql`
  ${LOCATION_FIELDS}
  mutation CreateLocation($name: String!, $timeZone: String!, $region: ID) {
    createLocation(name: $name, timeZone: $timeZone, region: $region) {
      ...LocationFields
    }
  }
`

const useMutationCreateLocation = () => useMutation(CREATE_LOCATION_MUTATION)

export { useMutationCreateLocation }
